<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import moment from "moment";
import { sessionHelper } from "@/utils";
import { SESSION, SHARED, DATE } from "@/constants";
import { mapState } from "vuex";
import { DOMAIN_MODULE } from '@/state/modules/domain'
import { domainMethods } from "@/state/helpers";

export default {
  page: {
    title: i18n.t("label.results"),
  },
  beforeRouteLeave(to, from, next) {
    sessionHelper.clearSearch(SESSION.DOMAIN_RESULTS_SEARCH)
    if (to.name != 'Domain-listing' && to.name != 'Domain-update' && to.name != 'Domain-create') {
      sessionHelper.clearSearch(SESSION.DOMAIN_SEARCH)
    }
    next();
  },
  async created() {
    this.searchCriteria = sessionHelper.retrieveSearch(SESSION.DOMAIN_SEARCH);
    this.domainId = this.searchCriteria.selectedRecordId;
    await this.validPermissions();
    this.initSearchCriteria();

    if (this.readPermission == true) {
      this.getDomain({ uuid: this.domainId });
    }
  },
  components: { Layout, PageHeader },
  data() {
    return {
      // Players first: what real visits saw is the answer an owner acts on.
      activeTab: 0,
      playerPage: 1,
      playerCriteria: { pageNumber: 1, pageSize: 25 },
      title: i18n.t("label.results"),
      items: [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.domain"),
          href: "/domain",
        },
        {
          text: i18n.t("label.results"),
          active: true,
        },
      ],
      domainId: null,
      currentPage: 1,
      permissions: sessionHelper.getPermissions(),
      readPermission: null,
      checkPermission: null,
      perPage: SHARED.DEFAULT_PAGE_SIZE,
      fields: [
        { key: "checkedAt", sortable: true, label: i18n.t("label.checkedAt"), },
        { key: "status", sortable: true, label: i18n.t("label.status"), },
        { key: "blockedAsns", sortable: false, label: i18n.t("label.blockedAsns"), },
        { key: "telegramSent", sortable: false, label: i18n.t("label.telegramSent"), },
        { key: "errorMessage", sortable: false, label: i18n.t("label.errorMessage"), },
        { key: "Action", sortable: false, label: i18n.t("label.action"), },
      ],
      detailFields: [
        { key: "asn", label: i18n.t("label.telco"), },
        { key: "verdict", label: i18n.t("label.verdict"), },
        { key: "probeSummary", label: i18n.t("label.blockedProbes"), },
        { key: "networks", label: i18n.t("label.networkBreakdown"), },
        { key: "source", label: i18n.t("label.source"), },
        { key: "evidence", label: i18n.t("label.evidence"), },
      ],
    };
  },
  computed: {
    ...mapState(DOMAIN_MODULE, ['status']),
    domainDetails() {
      return this.$store.state.domain.details;
    },
    playerFields() {
      return [
        { key: "measuredAt", label: i18n.t("label.checkedAt") },
        { key: "networkName", label: i18n.t("label.network") },
        { key: "opened", label: i18n.t("label.result") },
        { key: "elapsedMs", label: i18n.t("label.took") },
        { key: "controlOpened", label: i18n.t("label.control") },
      ];
    },
    playerRows() {
      return this.$store.state.domain.playerReports.data;
    },
    playerTotal() {
      return this.$store.state.domain.playerReports.pagination.total;
    },
    tableRows() {
      return this.$store.state.domain.results.data;
    },
    pagination() {
      return this.$store.state.domain.results.pagination;
    },
    totalPage() {
      return this.$store.state.domain.results.pagination.total;
    },
  },
  mounted() { },
  methods: {
    ...domainMethods,
    async validPermissions() {
      var jsonPermissions = JSON.parse(this.permissions)
      if (jsonPermissions.some(p => p.code === "DOMAIN_READ")) {
        this.readPermission = true;
      }
      else {
        this.readPermission = false;
      }

      if (jsonPermissions.some(p => p.code === "DOMAIN_CHECK")) {
        this.checkPermission = true;
      }
      else {
        this.checkPermission = false;
      }
    },
    initSearchCriteria() {
      let isDefault = true;

      if (sessionHelper.hasSearchCriteria(SESSION.DOMAIN_RESULTS_SEARCH)) {
        isDefault = false;
        this.resultsCriteria = sessionHelper.retrieveSearch(SESSION.DOMAIN_RESULTS_SEARCH);
        this.currentPage = this.resultsCriteria.pageNumber;
      }

      if (isDefault) {
        this.resultsCriteria = {
          pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
          pageSize: SHARED.DEFAULT_PAGE_SIZE,
        };
      }

      if (this.readPermission == true) {
        this.getResultList(this.resultsCriteria);
        this.getPlayerReportList(this.playerCriteria);
      }
    },

    getPlayerReportList(filter) {
      this.getPlayerReports({ uuid: this.domainId, filter });
      this.playerCriteria = filter;
    },

    playerPageNavigation(pageNumber) {
      this.getPlayerReportList({ ...this.playerCriteria, pageNumber });
    },

    getResultList(filter) {
      this.getDomainResults({ uuid: this.domainId, filter });
      this.resultsCriteria = filter;
      sessionHelper.storeSearch(SESSION.DOMAIN_RESULTS_SEARCH, filter);
    },

    pageNavigation(pageNumber) {
      let filter = sessionHelper.retrieveSearch(SESSION.DOMAIN_RESULTS_SEARCH);
      filter.pageNumber = pageNumber;

      this.getResultList(filter);
    },

    requestCheck() {
      if (this.checkPermission == true && !this.status.checking) {
        this.checkDomain({ uuid: this.domainId, resultsFilter: this.resultsCriteria });
        this.getPlayerReportList(this.playerCriteria);
      }
    },

    statusVariant(status) {
      // Colour says who has to act: red = a telco, dark = the registrar,
      // grey = DNS / hosting, yellow = a warning rather than an outage.
      return {
        OK: 'success',
        SUSPECT: 'warning',
        PARTIAL: 'warning',
        BLOCKED: 'danger',
        REAL_BLOCK: 'danger',
        ERROR_BLOCK: 'warning',
        REGISTRAR_SUSPENDED: 'dark',
        NOT_REGISTERED: 'dark',
        EXPIRED: 'dark',
        UNRESOLVABLE: 'secondary',
        SITE_DOWN: 'secondary',
        BROWSER_WARNING: 'warning',
        NO_DATA: 'light',
        ERROR: 'danger',
      }[status] || 'danger';
    },

    statusLabel(status) {
      return this.$te('enumDomainStatus.' + status) ? this.$t('enumDomainStatus.' + status) : status;
    },

    warningLabel(warning) {
      const code = warning && warning.code;
      return this.$te('enumWarning.' + code) ? this.$t('enumWarning.' + code) : code;
    },

    layerState(layer, key) {
      const state = layer && layer[key];
      if (!state) return '-';
      return this.$te('enumLayerState.' + state) ? this.$t('enumLayerState.' + state) : state;
    },

    layerVariant(state) {
      return {
        active: 'success', ok: 'success', up: 'success', clean: 'success',
        suspended: 'dark', deleting: 'dark', expired: 'dark', not_registered: 'dark',
        nxdomain: 'secondary', servfail: 'secondary', no_answer: 'secondary', down: 'secondary', tls_invalid: 'secondary',
        flagged: 'warning',
      }[state] || 'light';
    },

    networkSummary(detail) {
      const networks = detail && detail.networks ? Object.keys(detail.networks) : [];
      if (networks.length === 0) return '-';
      return networks.map((network) => {
        const counts = detail.networks[network];
        const name = this.$te('enumNetwork.' + network) ? this.$t('enumNetwork.' + network) : network;
        return `${name}: ${this.$t('label.samplesBlocked', [counts.blocked, counts.samples])}`;
      }).join(' · ');
    },

    sourceLabel(detail) {
      const sources = (detail && detail.sources) || [];

      if (sources.length === 0) {
        return '-';
      }

      return sources
        .map((s) => (this.$te('enumSource.' + s) ? this.$t('enumSource.' + s) : s))
        .join(', ');
    },

    hasLayers(item) {
      return item && item.layers && Object.keys(item.layers).some((key) => item.layers[key]);
    },

    asnLabel(detail) {
      if (!detail) return '-';
      return detail.asnName ? `${detail.asnName} (AS${detail.asn})` : `AS${detail.asn}`;
    },
    verdictVariant(verdict) {
      // SUSPECT is deliberately not red: it means a single probe saw something
      // odd, which is more often a household DNS filter than a real block.
      return {
        BLOCKED: 'danger',
        SUSPECT: 'warning',
        OK: 'success',
      }[verdict] || 'secondary';
    },

    formatDateTime(value) {
      return value ? moment(value).format(DATE.DATE_TIME_SHORT_TZ) : '-';
    },

  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="domainDetails.domain ? `${title} - ${domainDetails.domain}` : title" :items="items" />

    <div class="row" v-if="details && details.recentFailures && details.recentFailures.visitors > 0">

      <div class="col-12">

        <div class="card">

          <div class="card-body">

            <h5 class="card-title">{{ $t('label.playersCouldNotOpen') }}

              <small class="text-muted">({{ $t('label.lastXHours', [details.recentFailures.window_minutes / 60]) }})</small>

            </h5>

            <p class="text-muted small mb-2">{{ $t('message.recentFailuresHelp') }}</p>

            <b-badge :variant="details.recentFailures.failed > 0 ? 'danger' : 'success'" class="mr-2">

              {{ $t('label.playersFailedX', [details.recentFailures.failed, details.recentFailures.visitors, details.recentFailures.window_minutes / 60]) }}

            </b-badge>

            <b-badge v-for="n in details.recentFailures.networks" :key="n.asn || 'unknown'" class="mr-1"

              :variant="n.failed > 0 ? (n.telco ? 'danger' : 'secondary') : 'light'" v-b-tooltip.hover

              :title="n.telco ? $t('label.telco') : $t('label.notATelco')">

              {{ n.name }}: {{ n.failed }}/{{ n.total }}

            </b-badge>

          </div>

        </div>

      </div>

    </div>


    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <h4 class="card-title" v-if="domainDetails.domain">{{ domainDetails.domain }}</h4>
              </div>

              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-right" style="float: right">
                  <button type="button" style="float: right; margin-bottom: 10px" v-if="checkPermission == true"
                    class="btn btn-info w-md waves-effect waves-light" :disabled="status.checking != null && status.checking != undefined"
                    @click="requestCheck">
                    <b-spinner small v-if="status.checking"></b-spinner>
                    {{ $t('label.checkNow') }}
                  </button>
                </div>
              </div>
            </div>
            <b-tabs v-model="activeTab" class="mt-3">
            <b-tab :title="$t('label.playerReports')">
            <p class="text-muted small mt-3">{{ $t('message.playerReportsHelp') }}</p>
            <div class="table-responsive mb-0">
              <b-table :items="playerRows" :fields="playerFields" responsive="sm" show-empty
                :empty-text="$t('message.noPlayerReports')" v-if="readPermission == true">
                <template #cell(measuredAt)="data">
                  {{ formatDateTime(playerRows[data.index].measuredAt) }}
                </template>
                <template #cell(networkName)="data">
                  {{ playerRows[data.index].networkName || '-' }}
                  <b-badge variant="secondary" class="ml-1" v-if="!playerRows[data.index].isTelco"
                    v-b-tooltip.hover :title="$t('message.notATelcoHelp')">
                    {{ $t('label.notATelco') }}
                  </b-badge>
                  <div class="text-muted small" v-if="playerRows[data.index].networkType">
                    {{ playerRows[data.index].networkType }}
                  </div>
                </template>
                <template #cell(opened)="data">
                  <b-badge :variant="playerRows[data.index].opened ? 'success' : 'danger'">
                    {{ playerRows[data.index].opened ? $t('label.opened') : $t('label.couldNotOpen') }}
                  </b-badge>
                  <div class="text-muted small" v-if="playerRows[data.index].timedOut">{{ $t('label.timedOut') }}</div>
                </template>
                <template #cell(elapsedMs)="data">
                  {{ playerRows[data.index].elapsedMs != null ? playerRows[data.index].elapsedMs + ' ms' : '-' }}
                </template>
                <template #cell(controlOpened)="data">
                  <span v-if="playerRows[data.index].controlOpened === null" class="text-muted">-</span>
                  <b-badge v-else :variant="playerRows[data.index].controlOpened ? 'success' : 'warning'">
                    {{ playerRows[data.index].controlOpened ? $t('label.opened') : $t('label.couldNotOpen') }}
                  </b-badge>
                </template>
              </b-table>
              <div style="text-align: center;" v-else>{{ $t('message.noPermissionMessage') }}</div>
            </div>
            <div class="row" v-if="readPermission == true">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="playerPage" :total-rows="playerTotal" :per-page="perPage"
                      @change="playerPageNavigation"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            </b-tab>

            <b-tab :title="$t('label.monitorChecks')">
            <div class="table-responsive mb-0 mt-3">
              <b-table :items="tableRows" :fields="fields" responsive="sm" :per-page="perPage"
                v-if="readPermission == true">
                <template #cell(checkedAt)="data">
                  {{ formatDateTime(tableRows[data.index].checkedAt) }}
                </template>

                <template #cell(status)="data">
                  <b-badge :variant="statusVariant(tableRows[data.index].status)">
                    {{ statusLabel(tableRows[data.index].status) }}
                  </b-badge>
                  <div v-if="tableRows[data.index].warnings && tableRows[data.index].warnings.length > 0">
                    <b-badge variant="warning" class="mr-1 mt-1" v-for="(warning, index) in tableRows[data.index].warnings"
                      :key="index" v-b-tooltip.hover :title="warning.message">
                      {{ warningLabel(warning) }}
                    </b-badge>
                  </div>
                </template>

                <template #cell(blockedAsns)="data">
                  {{ tableRows[data.index].blockedAsnCount }} / {{ tableRows[data.index].totalAsnCount }}
                </template>

                <template #cell(telegramSent)="data">
                  <i class="mdi mdi-check-circle text-success font-size-18" v-if="tableRows[data.index].telegramSent"
                    v-b-tooltip.hover :title="$t('label.telegramSent')"></i>
                  <i class="mdi mdi-close-circle text-danger font-size-18"
                    v-else-if="tableRows[data.index].telegramError" v-b-tooltip.hover
                    :title="tableRows[data.index].telegramError"></i>
                  <span v-else>-</span>
                </template>

                <template #cell(errorMessage)="data">
                  {{ tableRows[data.index].errorMessage ? tableRows[data.index].errorMessage : '-' }}
                </template>

                <template #cell(action)="row">
                  <b-button size="sm" variant="outline-info" @click="row.toggleDetails"
                    v-if="(row.item.details && row.item.details.length > 0) || hasLayers(row.item)">
                    {{ row.detailsShowing ? $t('label.hideX', [$t('label.details')]) : $t('label.showX', [$t('label.details')]) }}
                  </b-button>
                </template>

                <template #row-details="row">
                  <b-card>
                    <!-- What each layer found. A problem here means no telco is involved. -->
                    <div class="row mb-3" v-if="hasLayers(row.item)">
                      <div class="col-md-3 col-sm-6 mb-2" v-if="row.item.layers.registry">
                        <div class="text-muted small">{{ $t('label.registry') }}</div>
                        <b-badge :variant="layerVariant(row.item.layers.registry.state)">
                          {{ layerState(row.item.layers.registry, 'state') }}
                        </b-badge>
                        <div class="small" v-if="row.item.layers.registry.expires_at">
                          {{ $t('label.expiresOn') }}: {{ row.item.layers.registry.expires_at.substring(0, 10) }}
                          <span v-if="row.item.layers.registry.days_to_expiry !== null">
                            ({{ $t('label.daysLeft', [row.item.layers.registry.days_to_expiry]) }})
                          </span>
                        </div>
                        <div class="small" v-if="row.item.layers.registry.registrar">
                          {{ $t('label.registrar') }}: {{ row.item.layers.registry.registrar }}
                        </div>
                        <div class="small text-muted" v-if="row.item.layers.registry.statuses && row.item.layers.registry.statuses.length">
                          {{ row.item.layers.registry.statuses.join(', ') }}
                        </div>
                      </div>
                      <div class="col-md-3 col-sm-6 mb-2" v-if="row.item.layers.dns">
                        <div class="text-muted small">{{ $t('label.globalDns') }}</div>
                        <b-badge :variant="layerVariant(row.item.layers.dns.state)">
                          {{ layerState(row.item.layers.dns, 'state') }}
                        </b-badge>
                        <div class="small text-muted" v-if="row.item.layers.dns.addresses && row.item.layers.dns.addresses.length">
                          {{ row.item.layers.dns.addresses.join(', ') }}
                        </div>
                      </div>
                      <div class="col-md-3 col-sm-6 mb-2" v-if="row.item.layers.site">
                        <div class="text-muted small">{{ $t('label.site') }}</div>
                        <b-badge :variant="layerVariant(row.item.layers.site.state)">
                          {{ layerState(row.item.layers.site, 'state') }}
                        </b-badge>
                        <span class="small" v-if="row.item.layers.site.status_code"> HTTP {{ row.item.layers.site.status_code }}</span>
                        <div class="small" v-if="row.item.layers.site.cert_days_left !== null && row.item.layers.site.cert_days_left !== undefined">
                          {{ $t('label.certificate') }}: {{ $t('label.daysLeft', [row.item.layers.site.cert_days_left]) }}
                        </div>
                        <div class="small text-muted" v-if="row.item.layers.site.error">{{ row.item.layers.site.error }}</div>
                      </div>
                      <div class="col-md-3 col-sm-6 mb-2" v-if="row.item.layers.browser">
                        <div class="text-muted small">{{ $t('label.browser') }}</div>
                        <b-badge :variant="layerVariant(row.item.layers.browser.state)">
                          {{ layerState(row.item.layers.browser, 'state') }}
                        </b-badge>
                        <div class="small text-muted" v-if="row.item.layers.browser.threats && row.item.layers.browser.threats.length">
                          {{ row.item.layers.browser.threats.join(', ') }}
                        </div>
                      </div>
                    </div>

                    <b-table :items="row.item.details" :fields="detailFields" small responsive="sm"
                      v-if="row.item.details && row.item.details.length > 0">
                      <template #cell(asn)="data">
                        {{ asnLabel(row.item.details[data.index]) }}
                      </template>
                      <template #cell(verdict)="data">
                        <b-badge :variant="verdictVariant(row.item.details[data.index].verdict)">
                          {{ $t('enumTelcoVerdict.' + row.item.details[data.index].verdict) }}
                        </b-badge>
                      </template>
                      <template #cell(probeSummary)="data">
                        {{ row.item.details[data.index].blockedProbeCount }}/{{ row.item.details[data.index].probeCount }}
                        <span class="text-muted small" v-if="row.item.details[data.index].untrustedCount">
                          (+{{ row.item.details[data.index].untrustedCount }} {{ $t('enumTelcoVerdict.SUSPECT').toLowerCase() }})
                        </span>
                      </template>
                      <template #cell(networks)="data">
                        <span class="small">{{ networkSummary(row.item.details[data.index]) }}</span>
                      </template>
                      <template #cell(source)="data">
                        <span class="small">{{ sourceLabel(row.item.details[data.index]) }}</span>
                      </template>
                      <template #cell(evidence)="data">
                        <span class="small">{{ row.item.details[data.index].evidence || '-' }}</span>
                      </template>
                    </b-table>
                  </b-card>
                </template>
              </b-table>
              <div style="text-align: center;" v-else>
                {{ $t('message.noPermissionMessage') }}
              </div>
            </div>
            <div class="row" v-if="this.readPermission == true">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="totalPage" :per-page="perPage"
                      @change="pageNavigation"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
